export enum EnumCurrency{
    RUB = 'rub',
    USD = 'usd',
}